export default {"src":"/_next/static/media/ksm.fb786037.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};